import { useQuery } from "@tanstack/react-query";
import {
  getExperiences,
  getAmenities,
  getTestimonials,
} from "@/lib/api/content";

export function useExperiences() {
  return useQuery({
    queryKey: ["experiences"],
    queryFn: getExperiences,
    staleTime: 10 * 60 * 1000,
  });
}

export function useAmenities() {
  return useQuery({
    queryKey: ["amenities"],
    queryFn: getAmenities,
    staleTime: 10 * 60 * 1000,
  });
}

export function useTestimonials() {
  return useQuery({
    queryKey: ["testimonials"],
    queryFn: getTestimonials,
    staleTime: 10 * 60 * 1000,
  });
}